module.exports = __webpack_public_path__ + "static/media/ilkley-38.68848861.jpg";